<template>
  <div class="farms-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'FarmsIndex'
}
</script>

<style scoped>
.farms-container {
  padding: 20px;
}
</style>
